import styled from 'styled-components';
export const LayoutContainer = styled.div `
  display: flex;
  flex-direction: column;

  width: 100%;
  min-height: 100%;
  height: -webkit-fill-available;

  background-color: ${({ theme }) => theme.colors.background.light};
`;
//# sourceMappingURL=LayoutContainer.js.map